import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getMarketsConfigs() {
    return {
        custom: {
            [PALETTE_IDS.MARKETS]: {},
        },
        palette: {
            [PALETTE_IDS.MARKETS]: {
                MARKETS_CONTAINER_HEADER_BET_BUILDER_ICON_COLOR: COLOR.BRAND.FOREGROUND1,
                MARKETS_CONTAINER_HEADER_CASHOUT_ICON_COLOR: COLOR.BRAND.FOREGROUND1,
                MARKETS_CORRECT_SCORE_PARTICIPANTS: {
                    PARTICIPANTS_TEXT: {
                        fontWeight: FONT.WEIGHT_MEDIUM,
                    },
                },
            },
        },
    };
}
